import { render, staticRenderFns } from "./MobileHelloWorld.vue?vue&type=template&id=4c0c1b5c&scoped=true"
import script from "./MobileHelloWorld.vue?vue&type=script&lang=js"
export * from "./MobileHelloWorld.vue?vue&type=script&lang=js"
import style0 from "./MobileHelloWorld.vue?vue&type=style&index=0&id=4c0c1b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c1b5c",
  null
  
)

export default component.exports